import { throttle } from 'throttle-debounce'

const productATCFixed = (): void => {
  const atcButtonWrapper = document.querySelector('[data-atc-wrapper]')
  const atcButton: HTMLButtonElement = document.querySelector(
    '[data-product-form-submit]'
  )
  const pdpBody = document.querySelector('body.template-product')

  if (!atcButtonWrapper) {
    return
  }
  //Set up variable that will become a function
  let scrollListener: () => void
  const MOBILE = 768
  const addFixedClass = (): void => {
    atcButtonWrapper.classList.remove('fixed')
    if (window.innerWidth < MOBILE) {
      //Get header height
      const headerHeight = parseInt(
        window
          .getComputedStyle(document.body)
          .getPropertyValue('--header-height-mb')
          ?.split('px')[0]
      )
      scrollListener = () => {
        const { height, top } = atcButtonWrapper.getBoundingClientRect()
        if (!isNaN(headerHeight)) {
          if (top < headerHeight - height && !atcButton.disabled) {
            atcButtonWrapper.classList.add('fixed')
            pdpBody.classList.add('pdp-scrolled-down')
          } else {
            atcButtonWrapper.classList.remove('fixed')
            pdpBody.classList.remove('pdp-scrolled-down')
          }
        }
      }
      window.addEventListener('scroll', scrollListener)
    }
  }
  addFixedClass()
  window.addEventListener('resize', () => {
    window.removeEventListener('scroll', scrollListener)
    throttle(500, false, addFixedClass())
  })
}

export default productATCFixed
